import { createFileRoute, redirect } from "@tanstack/react-router";

/** Superseded by the canvas devices panel on the console machines page. */
export const Route = createFileRoute("/dashboard/canvas")({
  beforeLoad: () => {
    throw redirect({ to: "/console/machines" });
  },
});
